// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'fingerprint-search';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 1.313A5.633 5.633 0 0 0 .562 6.188M11.7 5.077a5.29 5.29 0 0 0-.352-1.14m-5.16 13.501c.25 0 .501-.018.75-.053M.563 9.563v2.25a5.625 5.625 0 0 0 3.375 5.16' />
    <path d='M9.54 5.768A3.383 3.383 0 0 0 4.5 3.263M2.813 6.188v5.625a3.368 3.368 0 0 0 3.082 3.36M7.313 6.75v-.563a1.125 1.125 0 0 0-2.25 0v2.25m0 3.376a1.118 1.118 0 0 0 .622 1.004m6.128 2.933a3.938 3.938 0 1 0 0-7.875 3.938 3.938 0 0 0 0 7.875zm5.625 1.688-2.843-2.843' />
  </g>
);

export const viewBox = '0 0 18 18';
